<template>
    <div class="racecar">
        <h1> Let's Play!  </h1>
      <h1> 🚗 </h1>
        <race-car-function/>
    </div>
</template>
<script>
import RaceCarFunction from '@/components/RaceCarFunction.vue'

export default {
  components: { RaceCarFunction}
}
</script>
